import { render, staticRenderFns } from "./Campaign.vue?vue&type=template&id=aa865016"
import script from "./Campaign.vue?vue&type=script&lang=ts"
export * from "./Campaign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports